/**
 * Native EyeDropper API support (Spec 340) — feature detection + a thin open helper.
 * Kept separate from the button component so the component file only exports a
 * component (react-refresh / fast-refresh hygiene).
 */

/** Minimal typing for the native EyeDropper API (not yet in the TS DOM lib). */
interface EyeDropperResult {
  sRGBHex: string;
}
interface EyeDropperApi {
  open: (options?: { signal?: AbortSignal }) => Promise<EyeDropperResult>;
}
declare global {
  interface Window {
    EyeDropper?: new () => EyeDropperApi;
  }
}

/** Whether the browser exposes the native EyeDropper API (Chromium-only as of 2026). */
export function isEyeDropperSupported(): boolean {
  return typeof window !== 'undefined' && typeof window.EyeDropper === 'function';
}

/**
 * Open the native screen colour picker and resolve to the raw picked hex, or null
 * when unsupported or the user aborts (Esc). Never throws.
 */
export async function openEyeDropper(): Promise<string | null> {
  if (!isEyeDropperSupported()) return null;
  try {
    const dropper = new window.EyeDropper!();
    const { sRGBHex } = await dropper.open();
    return sRGBHex;
  } catch {
    return null;
  }
}
